module.exports = __webpack_public_path__ + "img/icon-lowcbd.1c6a71ec.svg";